export const createShippingOrder = (app, data, params) => {
  const url = 'shipping/order';
  const service = app.service(url);
  return service.create(data, params);
};

export const createShippingOrders = (app, data, params) => {
  const url = 'shipping/orders';
  const service = app.service(url);
  return service.create(data, params);
};

export const bookShippingOrders = (app, trackingNumbers, params) => {
  const url = 'shipping/orders/book';
  const service = app.service(url);
  const data = { trackingNumbers };
  return service.create(data, params);
};

export const cancelShippingOrder = (app, trackingNumber, params) => {
  const url = 'shipping/order';
  const service = app.service(url);
  return service.remove(trackingNumber, params);
};

export const trackShippingOrder = (app, trackingNumber, params) => {
  const url = 'shipping/order/track';
  const service = app.service(url);
  return service.get(trackingNumber, params);
};

export const getShippingOrder = (app, trackingNumber, params) => {
  const url = 'shipping/order';
  const service = app.service(url);
  return service.get(trackingNumber, params);
};

export const confirmShippingOrders = (app, data, params) => {
  const url = 'shipping/orders/confirm';
  const service = app.service(url);
  return service.create(data, params);
}

